define(["require", "exports", "./PhysicalScreen", "../Tenant"], function (require, exports, PhysicalScreen_1, Tenant_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AV2Box = (function () {
        function AV2Box(authcode) {
            if (authcode === void 0) { authcode = undefined; }
            this.Id = undefined;
            this.BoxId = undefined;
            this.BoxType = undefined;
            this.SerialNumber = undefined;
            this.Name = " ";
            this.Comment = undefined;
            this.CreatedAt = new Date(Date.now());
            this.ChangedAt = new Date(Date.now());
            this.LastSeenAt = new Date(Date.now());
            this.LastUpdateSentAt = new Date(Date.now());
            this.LastIP = undefined;
            this.IsAssigned = false;
            this.IsConnected = false;
            this.IsAuthenticated = false;
            this.AuthenticationCode = undefined;
            this.DisplayId = undefined;
            this.Display = new PhysicalScreen_1.PhysicalScreen();
            this.TenantId = undefined;
            this.Tenant = new Tenant_1.Tenant();
            this.AuthenticationCode = authcode;
        }
        return AV2Box;
    }());
    exports.AV2Box = AV2Box;
});
//# sourceMappingURL=AV2Box.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Configuration/AV2Box.js
// module id = 380
// module chunks = 0